import Fetch from '@/utils/Fetch';

const getCounts = async (id: any) => {
    let countRequest = await Fetch.get({
        url: `/Quote/GetCounts?id=${id}`,
    });
    let result = countRequest.Results;
    let attachmentCount = result.find((x: any) => x.Key == 'Attachments').Value;
    let communicationCount = result.find((x: any) => x.Key == 'Communication').Value;

    return {attachmentCount, communicationCount};
};

const getQuote = async (id: any) => {
    let quote = await Fetch.get({
        url: `/Quote/${id}`
    })
    return quote
};


export default {
    getCounts,
    getQuote
};
